export const progressCalculator = (statuses: {[key: string]: boolean}): number => {
  const statusesArray = Object.values(statuses)
  const positiveLength = statusesArray.filter(function (value) { return value }).length
  return 100 / statusesArray.length * positiveLength
}
